import { configureStore, combineReducers } from "@reduxjs/toolkit";
import {dashboardReducer} from "./Slices/DashboardSlices";


export const userStore = combineReducers({
  dashboardData: dashboardReducer
});